type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function CheckIcon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 20}
      height={props.height ?? 20}
      viewBox="0 0 20 20"
      fill={props.fill ?? 'none'}
      className={props.className}
    >
      <path
        d="M5.60059 10.8004L8.40059 13.6004L14.8006 6.40039"
        stroke={props.stroke ?? '#FA685B'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
